import reducers from './reducers';

export const NAME = 'reportChannel';
export default reducers;
